import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "data-item__section integration-subsystem-settings" };
const _hoisted_2 = { class: "data-item__section-title" };
const _hoisted_3 = { key: 0 };
import Fact from "@astina/paloma-common-ui/src/components/Fact.vue";
import ExportProfileTransferSftp from "./ExportProfileTransferSftp.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ShopIntegrationSubsystemSettings',
    props: {
        integration: {},
        subsystem: {}
    },
    setup(__props) {
        const props = __props;
        function statusFactVariant() {
            if (!props.subsystem) {
                return 'default';
            }
            switch (props.subsystem.subStatus) {
                case 'ok':
                    return 'success';
                case 'warning':
                case 'error':
                    return 'danger';
                case 'running':
                    return 'info';
                case 'requires_configuration':
                    return 'important';
            }
            return 'default';
        }
        /*
        function reportSearchRequest(): SearchRequest {
            return {
                query: null,
                filters: [{
                    attribute: 'process',
                    values: [`export_${props.subsystem.entityId}`]
                }],
            }
        }
         */
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.subsystem.label), 1),
                _cache[1] || (_cache[1] = _createTextVNode()),
                _createElementVNode("p", null, [
                    _createVNode(Fact, {
                        label: _ctx.$t('status'),
                        value: __props.subsystem.subStatusMessage,
                        variant: statusFactVariant()
                    }, null, 8, ["label", "value", "variant"]),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    (__props.subsystem.lastExecutionStart)
                        ? (_openBlock(), _createBlock(Fact, {
                            key: 0,
                            label: _ctx.$t('shop_integration.last_execution'),
                            value: _ctx.$dateTimeSec(__props.subsystem.lastExecutionStart)
                        }, null, 8, ["label", "value"]))
                        : _createCommentVNode("", true)
                ]),
                _cache[2] || (_cache[2] = _createTextVNode()),
                (_ctx.$te('shop_integration.' + __props.integration.name + '.' + __props.subsystem.name + '-description'))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$t('shop_integration.' + __props.integration.name + '.' + __props.subsystem.name + '-description')), 1))
                    : _createCommentVNode("", true),
                _cache[3] || (_cache[3] = _createTextVNode()),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.subsystem.requires, (required) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (required === 'export_profile_credentials' && __props.subsystem.entityId)
                            ? (_openBlock(), _createBlock(ExportProfileTransferSftp, {
                                key: required,
                                "profile-id": __props.subsystem.entityId
                            }, null, 8, ["profile-id"]))
                            : _createCommentVNode("", true)
                    ], 64));
                }), 256))
            ]));
        };
    }
});
